import Policy from '@/services/Policy';
import { useEffect, useState } from 'react';
import styles from './styles.less';

const NoticeBar: React.FC = () => {
    const [config, setConfig] = useState<{ message: string; color: string }>();

    useEffect(() => {
        getConfigurations();
    }, []);

    const getConfigurations = async () => {
        const data = await Policy.getSystemInfo();

        if (data.data === null) {
            return setConfig({
                message: '',
                color: '#005CA9',
            });
        }

        setConfig({
            message: data?.data.environment,
            color: data?.data?.color || '#005CA9',
        });
    };

    if (!config) return null;

    return (
        <div className={styles.containerNotice} style={{ backgroundColor: config.color }}>
            <div>{config.message}</div>
        </div>
    );
};

export default NoticeBar;
